export default "__VITE_ASSET__CBaKrafR__"